import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Calendar, Clock, Users } from "lucide-react";
import { CATEGORY_ICONS } from "../lib/constants";
import StatusBadge from "./StatusBadge";
import { useT } from "../i18n/I18nContext";

export default function RequestCard({ request, testid }) {
  const t = useT();
  const Icon = CATEGORY_ICONS[request.category] || CATEGORY_ICONS.other;
  const requester = request.requester;
  return (
    <Link
      to={`/app/richieste/${request.id}`}
      data-testid={testid || `request-card-${request.id}`}
      className="card-mabw p-6 block group anim-fade-up"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-stone-50 flex items-center justify-center text-mabw-secondary border border-mabw">
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-mabw-secondary font-semibold">
              {t(`categories.${request.category}.label`)}
            </div>
            <h3 className="text-lg font-semibold mt-1 group-hover:text-mabw-primary transition-colors" style={{ fontFamily: "Outfit" }}>
              {request.title}
            </h3>
          </div>
        </div>
        <StatusBadge status={request.status} />
      </div>

      <p className="mt-4 text-sm text-mabw-soft line-clamp-2 leading-relaxed">{request.description}</p>

      <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-mabw-soft">
        <span className="inline-flex items-center gap-1.5">
          <MapPin className="w-4 h-4" /> {request.location}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Calendar className="w-4 h-4" /> {request.date}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Clock className="w-4 h-4" /> {request.estimated_duration}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Users className="w-4 h-4" /> {request.offers_count || 0} {t("common.offers")}
        </span>
      </div>

      {requester && (
        <div className="mt-5 pt-4 border-t border-mabw flex items-center justify-between text-sm">
          <div className="text-mabw-soft">
            {t("common.from")} <span className="font-medium text-mabw-text">{requester.first_name} {requester.last_initial}</span> · {requester.city}
          </div>
          {requester.ratings_count > 0 && (
            <div className="text-mabw-text">★ {requester.avg_rating?.toFixed(1)} <span className="text-mabw-soft">({requester.ratings_count})</span></div>
          )}
        </div>
      )}
    </Link>
  );
}
